import { render } from "./setDiscount.vue?vue&type=template&id=5eb54519&scoped=true"
import script from "./setDiscount.vue?vue&type=script&lang=js"
export * from "./setDiscount.vue?vue&type=script&lang=js"

import "./setDiscount.vue?vue&type=style&index=0&id=5eb54519&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb54519"]])

export default __exports__